import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import {
  DRAWER_PARAM_KEYS,
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '@terminal/routes/query-params';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

interface OpenDrawerParams {
  id: string;
  entityTag?: string;
  trackingProperties: Record<string, unknown> & {
    source: PosthogTrackingSource;
  };
  relation?: string;
}

export const useInsightDrawer = () => {
  const { setQueryParams, deleteQueryParam } = useQueryParams();
  const { trackInsightsDrawerOpen } = usePosthogEvents();

  const openDrawer = ({
    id,
    entityTag,
    trackingProperties,
    relation,
  }: OpenDrawerParams) => {
    const { source, ...rest } = trackingProperties;
    trackInsightsDrawerOpen({
      ...rest,
      source,
      type: 'simple',
      insightId: id,
      entities: entityTag ? [entityTag] : undefined,
    });
    setQueryParams({
      ...getCleanDrawerParams(),
      [queryKeys.activeInsight]: id,
      [queryKeys.activeDrawer]: queryValues.insightsDrawer,
      [queryKeys.entityTag]: entityTag,
      [queryKeys.source]: source,
      [queryKeys.insightRelation]: relation ?? undefined,
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([...DRAWER_PARAM_KEYS, queryKeys.drawerExpanded], {
      replace: true,
    });
  };

  return {
    openDrawer,
    closeDrawer,
  };
};
